import styled, { device } from "@styled";

export const SolutionsWrapper = styled.section`
    padding-block-start: 53px;
    padding-block-end: 56px;
    background-color: #f8f8f8;
    ${device.medium} {
        padding-block-start: 73px;
        padding-block-end: 76px;
    }
    ${device.large} {
        padding-block-start: 20px;
        padding-block-end: 20px;
    }
`;

export const SolutionBox = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;
// margin-block-start: 40px;

export const SolutionBoxItem = styled.div`
    max-width: 100%;
    flex-basis: 100%;
    ${device.large} {
        max-width: 100%;
        flex-basis: 100%;
        padding-inline-end: 0px;
    }
`;

export const StyledHeading = styled.h3`
    text-align: center;
    margin-block-end: 10px;
    ${device.medium} {
        margin-block-end: 20px;
    }
`;
